export default {
  styleOverrides: {
    '.MuiDivider-middle': {
      padding: '0 16px'
    }
  }
}
